<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <b-button size="sm" variant="outline-secondary" @click="logout">Logout</b-button>
    <h5 class="username">{{ username }} ({{role}})</h5>

    <CRenderFunction flat :content-to-render="navShow"/>

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import allNav from './_nav'
// import saleNav from './_saleNav'
import scanNav from './_scanNav'
import productNav from './_productNav'
import productPostingNav from './_productPostingNav'
import clientNav from './_clientNav'
import toolNav from './_toolNav'

import Firebase from "@/services/firebase.js";

export default {
  name: 'TheSidebar',
  // adminNav,
  // saleNav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    },
    username(){
      if (this.user.data.email) {
        return this.user.data.email
      }
      return null
    },
    role() {
      console.log('TheSideBar::role::trying to get user role: ', this.$store.state.userRole)
      if (this.$store.state.userRole) {
        return this.$store.state.userRole;
      }

      return 'sale'; // default role
    },
    permissions() {
      console.log('heSideBar::permission::trying to get user permissions: ', this.$store.state.permissions)
      if (this.$store.state.permissions) {
        return this.$store.state.permissions;
      }

      return []; // default role
    },
    navShow() {
      const accept = this.$store.state.accept;
      console.log('TheSideBar::navShow::trying to get user accept: ', this.$store.state.accept);

      const access_control_type = this.$store.state.access_control_type;
      const permissions = this.$store.state.permissions;
      console.log('TheSideBar::navShow::trying to get access_control_type: ', this.$store.state.access_control_type);
      console.log('TheSideBar::navShow::trying to get permissions: ', this.$store.state.permissions);
      console.log('TheSideBar::navShow::allNav ', allNav);

      /*
       Updated 2024-04-07: implement permission-based access control
      */
      if(access_control_type === 'permission') {
        // Convert permission from array to map
        const permissionMap = permissions;

        var navs = [];

        for(var i=0; i<scanNav.open.length; i++) {
          if(scanNav.open[i].permission && permissionMap[scanNav.open[i].permission]) {
            navs.push(scanNav.open[i]);
          }
          else if(scanNav.open[i]._name === 'CSidebarNavTitle') {
            navs.push(scanNav.open[i]);
          }
        }

        for(var i=0; i<productNav.open.length; i++) {
          if(productNav.open[i].permission && permissionMap[productNav.open[i].permission]) {
            navs.push(productNav.open[i]);
          } else if(productNav.open[i]._name === 'CSidebarNavTitle') {
            navs.push(productNav.open[i]);
          }
        }

        for(var i=0; i<productPostingNav.open.length; i++) {
          if(productPostingNav.open[i].permission && permissionMap[productPostingNav.open[i].permission]) {
            navs.push(productPostingNav.open[i]);
          } else if(productPostingNav.open[i]._name === 'CSidebarNavTitle') {
            navs.push(productPostingNav.open[i]);
          }
        }

        for(var i=0; i<clientNav.length; i++) {
          if(clientNav[i].permission && permissionMap[clientNav[i].permission]) {
            navs.push(clientNav[i]);
          } else if(clientNav[i]._name === 'CSidebarNavTitle') {
            navs.push(clientNav[i]);
          }
        }

        for(var i=0; i<toolNav.length; i++) {
          if(toolNav[i].permission && permissionMap[toolNav[i].permission]) {
            navs.push(toolNav[i]);
          } else if(toolNav[i]._name === 'CSidebarNavTitle') {
            navs.push(toolNav[i]);
          }
        }

        return [{
          _name: 'CSidebarNav',
          _children: navs
        }];
      }
     
      var navs = [];

      if (accept.includes('scan')) {
        if (this.role == 'sale') {
          navs = [...navs, ...scanNav.sale_limited];
        } else {
          navs = [...navs, ...scanNav.open];
        }
      }

      if (accept.includes('product')) {
        if (this.role == 'ctv') {
          navs = [...navs, ...productNav.limited];
        } else if (this.role == 'sale') {
          navs = [...navs, ...productNav.sale_limited];
        } else {
          navs = [...navs, ...productNav.open];
        }
      }

      if (accept.includes('product_posting')) {
        if (this.role == 'sale') {
          navs = [...navs, ...productPostingNav.sale_limited];
        } else {
          navs = [...navs, ...productPostingNav.open];
        }
      }

      if (accept.includes('product_posting_view')) {
        if (this.role == 'sale') {
          navs = [...navs, ...productPostingNav.ctv_limited];
        } else {
          navs = [...navs, ...productPostingNav.open];
        }
      }

      if (accept.includes('client')) {
        navs = [...navs, ...clientNav];
      }

      if (accept.includes('tool')) {
        navs = [...navs, ...toolNav];
      }

      return [{
        _name: 'CSidebarNav',
        _children: navs
      }];
    }
  },
  data() {
    return {
      user: {
        data: {}
      },
    };
  },
  methods: {
    logout() {
      Firebase.logout()
        .then(() => {
          console.log("logout!");
          window.location.reload(); 
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  mounted() {
    Firebase.auth.onAuthStateChanged( user => {
      if (user) {
        this.user.data = user;
      }
    })
  }
}
</script>

<style lang="css">
.username {
  margin: 10px 15px;
  color: yellow;
}
</style>